export const ROW_DRAG_TYPE = "@@gannt/ROW_DRAG";
export const SCROLL_STEP = 10;


